<template>
    <div class="ur-text-field ur-input" :class="textfieldClass">
        <textarea ref="input"
                  v-model="txtField"
                  class="ur-text-field__textarea"
                  :rows="$_rows"
                  :placeholder="placeholder"
                  :disabled="disabled"
                  :readonly="readonly"
                  :onfocus="readonly&&'this.blur();'"
                  :style="{resize: resize}"
                  :tabindex="tabindex"
                  v-on="listenersWithoutInput"
                  @keyup.enter="enterHandler"
                  @blur="validateOnEvent"></textarea>
        <div v-if="messageShow || counter" :style="$_messageStyle()"
             class="ur-text-field__message ur-validator__message"
             :class="messageClass">{{messageShow}}<!--glue
        --><div v-if="counter && counterShow === true" class="ur-text-field__counter"><!--glue
            -->{{typeof(txtField) === 'string'?getStringLength(txtField):0}}/{{counter}}<!--glue
        --></div><!--glue
    --></div>
    </div>
</template>

<script>
import urValidatorMixin from '@uidev/mixins/urValidator/urValidatorMixin.vue';
// 가장 간단한 형식의 ur-text-area는 여러 줄의 텍스트 필드로, 많은 양의 텍스트에 유용합니다
// #ur-text-area in its simplest form is a multi-line text-field, useful for larger amounts of text.
export default {
    name: 'aicc-text-area',
    mixins: [urValidatorMixin],
    inject: {
        urInput: {from:'urInput', default: () => undefined}
    },
    props:
    /* [FROM VALIDATOR] */
    // rules
    // disabled
    // lazy
    // noShake
    /********************/
    {
        // $ver: v0.1.0
        // $v-model
        // v-model로 바인딩되는 값으로, 텍스트필드의 값과 연계됩니다.
        // #The value bound to v-model, associated with the value of the textfield.
        // $tags IDE, value
        value: [String],

        // $ver: v0.1.0
        // 텍스트 필드가 빈 값일 때 표시할 문자열 입니다.
        // #The string to display when the text field is empty.
        // $tags IDE, placeholder
        placeholder: {type: String},

        // $ver: v0.1.0
        // Guide 메시지로 표시할 문자열 입니다.
        // #The string to display as the guide message.
        guideMessage: {type: String, default: undefined},

        // $ver: v0.1.0
        // Success 메시지로 표시할 문자열 입니다.
        // #The string to display as a Success message.
        successMessage: {type: String, default: undefined},

        // $ver: v0.1.0
        // 다중라인 텍스트필드일 때 표시될 행의 숫자 입니다.
        // #The number of lines to display when in a multiline text field.
        // $tags IDE, rows
        rows: {type: [String, Number], default: 3},

        // $ver: v0.1.0
        // 다중라인 텍스트필드일 때 리사이즈 기능 동작 여부입니다. 우측하단을 선택/드래그 하여 리사이즈를 할 수 있습니다.
        // 'none','both', 'horizontal', 'vertical' 속성을 지정할수 있습니다.
        // #Whether the resize function works for multiline text fields. You can resize by selecting and dragging the lower right corner.
        // #You can specify the 'none','both', 'horizontal', 'vertical'.
        // $tags IDE, resize
        resize: {type: String, default: 'none'},

        // $ver: v0.1.0
        // 가이드, 성공, 안내메시지 표현 형태 속성입니다. 'heavy', 'light' 속성을 지정할 수 있습니다.
        // #Guide, Success, Announcement appearance attributes. You can specify the 'heavy' and 'light' attributes.
        messageStyle: {
            type: String,
            validator: function(value) {
                return ['heavy', 'light'].indexOf(value) !== -1;
            },
            default: 'heavy'
        },

        // $ver: v0.1.0
        // 비활성화 상태로 전환합니다.
        // #Switch to inactive state.
        // $default: false
        // $tags IDE, resize
        disabled: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 읽기전용 상태로 전환합니다. 비활성화와는 다르게 커서를 위치시킬 수 있으며, 드래그로 문자열을 선택할 수 있습니다.
        // #Switch to read-only state. Unlike deactivation, you can position the cursor and drag to select a string.
        // $default: false
        // $tags IDE, readonly
        readonly: {type: Boolean, default: false},
        
        // $ver: v0.1.0
        // 입력될 문자열의 최대 길이 값을 지정합니다. urValidator 연계로 실제 값 유효성 검사를 수행해야 합니다. 이 속성이 입력되면 우측 하단에 입력된 문자열의 길이를 표시합니다.
        // #Specifies the maximum length value of the string to be entered. You must perform actual value validation with the urValidator linkage.
        // #When this property is entered, it displays the length of the entered text in the lower right corner.
        // $tags IDE, counter
        counter: {type: [String, Number], default: undefined},

        // 글자수 세는 단위
        // byte : 바이트 단위로 입력 글자수를 센다. 한글은 2, 영어 숫자는 1.
        // character : 영어든 한글이든 한자든 글자 하나는 1.
        counterUnit: {
            type: String,
            default: 'byte',
            validator: function (value) {
                return ['byte', 'character'].indexOf(value) !== -1
            }
        },

        // 글자수 숫자 보여주기 여부, 기본은 true
        counterShow: {
            type: Boolean,
            default: true,
        },

        // 실시간 Valid Check 여부, 기본은 true
        realTimeValidate :{
            type: Boolean,
            default: true,
        },

        // $ver: v0.2.0
        // 크기 입니다. 'large','medium','small' 두 가지 중 하나를 입력해야 합니다.
        // #The size You must enter one of three types: large, medium, small.
        // $default: medium
        // $tags IDE, size
        size: {
            validator: function (value) {
                // The value must match one of these strings
                return ['large','medium', 'small'].indexOf(value) !== -1
            },
            // type: String,
            //default: 'medium'
        },

        // $ver: v0.1.0
        // 컴포넌트를 Large 크기로 조정합니다.
        // #Resize the component to large size.
        // $default: false
        large: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 컴포넌트를 Medium 크기로 조정합니다.
        // #Resize the component to medium size.
        // $default: false
        medium: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 컴포넌트를 Small 크기로 조정합니다.
        // #Resize the component to Small.
        // $default: false
        small: {type: Boolean, default: false},

        // $ver: v0.1.2
        // tabindex를 설정합니다.
        // #Set tabindex.
        tabindex: {type:[Number,String]},

        // $ver: v0.1.0
        // large 속성의 약어입니다.
        // $abbr: large
        lg: {type: Boolean, default: false}, // large

        // $ver: v0.1.0
        // medium 속성의 약어입니다.
        // $abbr: medium
        md: {type: Boolean, default: false}, // medium

        // $ver: v0.1.0
        // small 속성의 약어입니다.
        // $abbr: small
        sm: {type: Boolean, default: false}, // small

        // $ver: v0.1.0
        // readonly 속성의 약어입니다.
        // $abbr: readonly
        ro: {type: Boolean, default: false}, // readonly
    },
    data: function () {
        return {
            /* [FROM VALIDATOR] */
            // hasError
            // errorMessage
            // showValid
            // shake
            /********************/
            default: {
                size: 'medium'
            },
            txtField: '', // shown in <input/> tag
            realText: '', // emitted data to parent component. if you use mask props, realText may differ from txt Field
        };
    },
    computed: {
        /* [FROM VALIDATOR] */
        // isValidatable
        // el
        validateTarget() {return this.value;}, // validation setting
        /********************/

        $_size() {
            if((this.size && this.small) || (this.size && this.medium)|| (this.size && this.large)){
                console.warn("Props related size are duplicated.")
            }
            switch(this.size){
                case 'small':   return 'small';
                case 'medium' : return 'medium';
                case 'large' : return 'large';
            }

            if(this.large || this.lg) {return 'large'}
            if(this.medium || this.md) {return 'medium'}
            if(this.small || this.sm) {return 'small'}
            if(this.urInput) {return this.urInput.size}
            return this.default.size;
        },
        $_rows() {return parseInt(this.rows);},
        textfieldClass() {
            let clazz = [];
            clazz.push('ur-text-field--'+this.$_size);

            if(this.errorMessage) {clazz.push('ur-text-field--has-message')}
            if(this.hasError === true) {clazz.push('ur-validator--error')}
            if(this.showValid && this.hasError === false) {clazz.push('ur-validator--valid')}
            if(this.shake) {clazz.push('ur-validator--shake')}
            return clazz;
        },
        listenersWithoutInput() {
            /*delete this.$listeners.input;
            return this.$listeners;/*/
            return Object.assign({}, this.$listeners, {
                input: function(event){ }//vm.$emit('input',event.target.value);
            });/**/
        },
        messageShow() {
            if(this.hasError === undefined) {
                return this.guideMessage;
            }
            if (this.hasError === true) {
                return this.errorMessage;
            }
            if (this.hasError === false) {
                return this.successMessage || this.guideMessage;
            }
            return undefined;
        },
        messageClass() {
            return ['ur-text-field__message--'+this.messageStyle];
        },

    },
    watch: {
        successMessage: {
            immediate: true,
            handler(val) {
                this.showValid = !!val;
            }
        },

        txtField(newText, oldText) {
            if (newText === oldText) {
                return;
            }
            this.realText = newText;
            // $ver: v0.1.0
            // $arg: updated value
            // 입력 값이 변경될 때, 변경된 값을 파라미터로 이벤트를 발생시킵니다.
            // #When the input value is changed, an event is triggered with the changed value as a parameter.
            this.$emit('input', newText);
            return;

        },
        value: {
            immediate: true,

            handler(newVal, oldVal) {
                this.txtField = newVal;
                // 1. 실시간 Option이 활성화일 경우 Valid 검사
                // 2. 페이지 첫 진입시 빈 칸인 경우 Valid 검사 제외
                if(this.realTimeValidate && this.realTimeValidate === true) {
                    if((!newVal || newVal === null) && (!oldVal || oldVal === null)) {
                        return;
                    }
                    this.validateOnEvent();
                    if(this.isValid() === false) {
                        this.$emit('invalid');
                    }
                }
            }

            // counter를 초과하면 Max Length 이후를 자르는 경우
            /*
             handler(newVal, oldVal) {
                 if (this.counter && this.getStringLength(newVal) > this.counter) {
                     const cursorPosition = this.$refs['input'].selectionStart;
                    if (this.counterUnit === 'byte') {
                        newVal = aiccUtils.sliceStringByByte(newVal, this.counter);
                    } else if (this.counterUnit === 'character') {
                        newVal = newVal.substring(0, this.counter);
                    }
                    this.txtField = newVal;
                    this.$nextTick(() => {
                        this.$refs['input'].setSelectionRange(cursorPosition, cursorPosition);
                    });
                 } else {
                     this.txtField = newVal;
                 }
             }
             */
        }
    },
    methods: {
        /* [FROM VALIDATOR] */
        // validate()        --+
        // isValid()         --+-- exposed methods for manual validate control
        // clearValidation() --+
        // vavlidateOnEvent() -> should be set by each component which uses urValidatorMixin
        /********************/
        enterHandler: function () {
            // $ver: v0.1.0
            // $arg: value
            // 엔터 키 입력 시, 현재 값을 파라미터로 이벤트를 발생시킵니다.
            // #When enter key is pressed, an event is triggered with the current value as a parameter.
            this.$emit('enter', this.txtField);
        },
        focus() {this.$refs.input.focus();},
        blur() {this.$refs.input.blur();},
        getStringLength() {
            if (this.counterUnit === 'byte') {
                return aiccUtils.getStringByteSize(this.txtField);

            } else if (this.counterUnit === 'character') {
                return this.txtField.length;

            } else {
                return 0;
            }
        },
    },
};
</script>
